import React from 'react';

import { OrdCreate, OrdEdit, OrdShow } from '@ragu-components/ord-components';

import { ApTemplatesForm } from './ApTemplatesForm';

import type { OrdResourceProps } from '@ragu-components/ord-resources';
import type { ApTemplate } from '@ragu-components/ord-types';

const ApTemplatesList = React.lazy(async () => import('./ApTemplatesList'));

export const apTemplatesResource: OrdResourceProps = {
  key: 'ap_templates',
  name: 'ap_templates',
  list: <ApTemplatesList />,
  create: (
    <OrdCreate>
      <ApTemplatesForm />
    </OrdCreate>
  ),
  edit: (
    <OrdEdit>
      <ApTemplatesForm />
    </OrdEdit>
  ),
  show: (
    <OrdShow>
      <ApTemplatesForm />
    </OrdShow>
  ),
  options: {},
  recordRepresentation: (record: ApTemplate) => record.name,
};
